import { Http } from '../helpers'

export const NotificationService = {
  async search(params) {
    return await Http.get('/notification', { params: params })
  },
  async report() {
    return await Http.get('/notification/report')
  },
  async listType() {
    return await Http.get('/notification/list-type')
  },
  async setReaded(id, params = {}) {
    return await Http.put('/notification/' + id + '/set-readed', params)
  },
  async create(params) {
    return await Http.post('/notification', params)
  },
  async view(id) {
    return await Http.get('/notification/' + id)
  },
  async cancel(id) {
    return await Http.put('/notification/' + id + '/cancel')
  },
  async close(id) {
    return await Http.put('/notification/' + id + '/close')
  },
  async delete(id) {
    return await Http.delete('/notification/' + id)
  },
}
